import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useSmartBack } from '@/composables/use-smart-back'
import {
  Button as VanButton,
  CellGroup,
  Field,
  NavBar as VanNavBar,
  showFailToast,
  showSuccessToast,
  showToast,
} from 'vant'
import { useCountdown } from '@/composables/use-countdown'
import { useServerCaptcha } from '@/composables/use-server-captcha'
import { renderPhoneSmsFields } from '@/components/sms-code-fields'
import { postApiV1UserChangePassword } from '@/api/sdk.gen'

export default defineComponent({
  name: 'ForgotPasswordPage',
  setup() {
    const router = useRouter()
  const goBack = useSmartBack()

    const phone = ref('')
    const captchaInput = ref('')
    const code = ref('')
    const newPassword = ref('')
    const confirmPassword = ref('')
    const sendLoading = ref(false)
    const submitLoading = ref(false)
    const {
      captchaId,
      captchaImage,
      refresh: refreshCaptcha,
      sendSmsCode,
    } = useServerCaptcha()
    const { countdown, isCounting, start } = useCountdown()

    async function handleSendCode() {
      if (phone.value.length !== 11) return showToast('请输入正确的手机号')
      if (!captchaInput.value) return showToast('请输入图形验证码')
      sendLoading.value = true
      await sendSmsCode({
        captchaCode: captchaInput.value,
        account: phone.value,
        scene: 'pwd-reset',
        failText: '验证码发送失败',
        successText: '验证码已发送',
        onSent: start,
      })
      sendLoading.value = false
    }

    async function handleReset() {
      if (phone.value.length !== 11) return showToast('请输入正确的手机号')
      if (!code.value) return showToast('请输入短信验证码')
      if (newPassword.value.length < 6) return showToast('新密码长度不能少于 6 位')
      if (newPassword.value !== confirmPassword.value) return showToast('两次输入的密码不一致')
      submitLoading.value = true
      try {
        const res = await postApiV1UserChangePassword({
          body: {
            channel: 'phone',
            account: phone.value,
            code: code.value,
            password: newPassword.value,
            password_confirm: confirmPassword.value,
            captcha_id: captchaId.value,
            captcha_code: captchaInput.value,
          } as never,
        })
        const body = (res.data ?? res.error) as { code: number; message: string } | undefined
        if (body?.code !== 0) {
          showFailToast(body?.message || '密码重置失败')
          refreshCaptcha()
          return
        }
        showSuccessToast('密码重置成功，请重新登录')
        router.replace('/login')
      } catch {
        showFailToast('重置失败，请稍后重试')
        refreshCaptcha()
      } finally {
        submitLoading.value = false
      }
    }

    return () => (
      <div class="forgotpwd-wrap">
        <VanNavBar fixed title="找回密码" leftArrow onClickLeft={() => goBack()} />

        <CellGroup class="register-body" border={false}>
          {renderPhoneSmsFields({
            phone,
            captchaInput,
            code,
            captchaImage: captchaImage.value,
            refreshCaptcha,
            codeButtonText: isCounting.value ? `${countdown.value}s` : '获取验证码',
            onGetCode: () => {
              if (!isCounting.value && !sendLoading.value) handleSendCode()
            },
          })}

          <Field
            v-model={newPassword.value}
            label="密 码"
            placeholder="请输入6-16数字或字母密码"
            type="password"
            maxlength={32}
          />

          <Field
            v-model={confirmPassword.value}
            label="重复密码"
            placeholder="请再次输入密码"
            type="password"
            maxlength={32}
          />
        </CellGroup>

        <VanButton class="primary-btn" loading={submitLoading.value} onClick={handleReset}>
          完成
        </VanButton>
      </div>
    )
  },
})
